import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Text } from 'components/chroma';

const Center = styled.div`
  text-align: left;
`;

export const AnotherPayment: FunctionComponent = () => (
  <Center>
    <Text>
      Would you like to <Link to="/payment">make another payment?</Link>
    </Text>
  </Center>
);
